/* WSI cart upgrades (2026-10-15 - docs/superpowers/specs/2026-10-15-storefront-cart-upgrades-design.md).
   Every product card adds a box with one tap (no popup) and takes one back out; the pink plane flies to the cart;
   the product page says how many boxes are in the cart; "Continue shopping" goes back to the listing page the shopper
   came from. layout/theme.liquid does not load this file on the ice cream pallet builder or the Build-a-Bundle page.
   The pure helpers at the top run in node too (shopify/tests/cart_plus_logic.test.js). */
(function (root, factory) {
  var core = factory();
  if (typeof module === 'object' && module.exports) module.exports = core;
  else root.WSICartPlus = core;
  if (typeof document !== 'undefined' && root.WSI_CART_PLUS && typeof core.start === 'function') core.start(root.WSI_CART_PLUS);
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';

  /* boxes in the cart per product id - every line of a product counts (a line with properties, like the
     Build-a-Bundle free case, too) */
  function counts(cart) {
    var out = {};
    ((cart && cart.items) || []).forEach(function (li) {
      var k = String(li.product_id);
      out[k] = (out[k] || 0) + (Number(li.quantity) || 0);
    });
    return out;
  }

  /* the line one Remove takes a box from: the product's last plain line (no properties) first, so a Build-a-Bundle
     pick is the last thing touched; null when the product is not in the cart */
  function lastLine(cart, productId) {
    var plain = null, any = null, pid = String(productId);
    ((cart && cart.items) || []).forEach(function (li) {
      if (String(li.product_id) !== pid || !(Number(li.quantity) > 0)) return;
      any = li;
      var props = li.properties || {};
      var hasProps = Object.keys(props).some(function (k) { return props[k] !== null && props[k] !== ''; });
      if (!hasProps) plain = li;
    });
    var li = plain || any;
    return li ? { key: li.key, quantity: Number(li.quantity) } : null;
  }

  /* the pages "Continue shopping" goes back to: categories, search results, the root page and /pages/home */
  function isListing(page, suffix) {
    return page === 'collection' || page === 'search' || page === 'index' || (page === 'page' && suffix === 'home');
  }

  /* one page's address: path and query, without the #hash, a trailing slash or Shopify's preview parameter */
  function norm(u) {
    try {
      var x = new URL(String(u), 'https://www.worldwidesnacksinc.com');
      x.hash = '';
      x.searchParams.delete('preview_theme_id');
      var q = x.searchParams.toString();
      return x.origin + (x.pathname.replace(/\/+$/, '') || '/') + (q ? '?' + q : '');
    } catch (e) { return String(u); }
  }
  function sameUrl(a, b) { return !!a && !!b && norm(a) === norm(b); }

  /* what the popup's "Continue shopping" does: 'close' (as today), 'back' (the browser's Back - the listing page is
     the page before this one, so it comes back instantly at its scroll) or 'go' (open the remembered listing page) */
  function backTarget(saved, here, referrer, historyLength, page) {
    if (page !== 'product' || !saved || !saved.url || sameUrl(saved.url, here)) return { mode: 'close' };
    if (referrer && sameUrl(saved.url, referrer) && historyLength > 1) return { mode: 'back' };
    return { mode: 'go', url: saved.url };
  }

  /* the cart page's "Continue shopping" address */
  function continueHref(saved) { return (saved && saved.url) || '/pages/home'; }

  /* the plane's path (a size x size box): from the button to the cart icon on an arc 60 px above the higher end,
     shrinking as it lands */
  function flightKeyframes(from, to, size) {
    var h = (size || 30) / 2;
    function at(x, y, s, r) {
      return 'translate(' + Math.round(x - h) + 'px,' + Math.round(y - h) + 'px) scale(' + s + ') rotate(' + r + 'deg)';
    }
    return [
      { transform: at(from.x, from.y, 1, -10), opacity: 1 },
      { transform: at((from.x + to.x) / 2, Math.min(from.y, to.y) - 60, 0.8, 6), opacity: 1, offset: 0.55 },
      { transform: at(to.x, to.y, 0.35, 18), opacity: 0.9 }
    ];
  }

  /* where the plane lands: the cart icon's centre, or the top-right corner when the icon is missing or off screen */
  function landing(rect, vw, vh) {
    if (!rect || !rect.width || rect.bottom < 0 || rect.top > vh || rect.right < 0 || rect.left > vw) return { x: vw - 32, y: 28 };
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  /* Shopify's refusal in its own words when it gives them */
  function errorText(status, body) {
    if (body && body.description) return String(body.description);
    if (status === 422) return 'That is all we have in stock right now.';
    return 'Try again';
  }

  /* one request at a time per product: three fast taps are three boxes, in order; a failed one does not stop the next */
  function serial() {
    var chains = {};
    return function (key, fn) {
      var next = (chains[key] || Promise.resolve()).then(fn, fn);
      chains[key] = next.then(function () {}, function () {});
      return next;
    };
  }

  var core = { counts: counts, lastLine: lastLine, isListing: isListing, sameUrl: sameUrl, backTarget: backTarget,
               continueHref: continueHref, flightKeyframes: flightKeyframes, landing: landing, errorText: errorText,
               serial: serial, state: {}, lastFlight: null, started: false };

  /* ---------- in the browser (core.start runs once, from the wrapper above) ---------- */
  var BACK = 'wsiCartBack', GO = 'wsiCartBackGo';
  var PLANE = '<svg viewBox="-10 -10 20 20" width="30" height="30" aria-hidden="true" focusable="false"><path d="M11.6,3.4 L9.5,5.5 L1.2,3.4 C1,3.36 0.8,3.42 0.7,3.6 L0.5,3.9 C0.4,4.18 0.45,4.5 0.66,4.7 L5.5,8.5 L4,10.4 L1.4,9.7 L0.7,10.4 L2.5,11.5 L3.6,13.4 L4.3,12.7 L3.6,10.1 L5.5,8.6 L9.3,13.4 C9.5,13.65 9.8,13.7 10.07,13.55 L10.4,13.34 C10.6,13.2 10.7,12.95 10.66,12.7 L8.6,4.5 L10.7,2.4 C11.45,1.55 11.7,0.5 11.45,-0.05 C10.95,-0.32 9.95,-0.07 9.1,0.7 L11.6,3.4 Z" fill="#EC5D99" stroke="#EC5D99" stroke-width="0.6" stroke-linejoin="round" stroke-linecap="round" transform="rotate(35) translate(-6 -6)"/></svg>';

  /* this tab's memory; private browsing can refuse it - then nothing is remembered */
  function keep(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function read(k) { try { return JSON.parse(sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } }
  function route(k, d) { return (window.routes && window.routes[k]) || d; }

  core.start = function (cfg) {
    if (core.started) return;
    core.started = true;
    var run = serial(), seq = 0;
    function icon() { return document.getElementById('cart-icon-bubble'); }

    var live = document.createElement('div');   /* said aloud by screen readers */
    live.className = 'visually-hidden';
    live.setAttribute('aria-live', 'polite');
    document.body.appendChild(live);
    function say(t) { live.textContent = ''; setTimeout(function () { live.textContent = t; }, 30); }

    /* the header's cart count, from the section Shopify sends back with each change */
    function bubble(sections) {
      var html = sections && sections['cart-icon-bubble'], el = icon();
      if (!html || !el) return;
      var doc = new DOMParser().parseFromString(html, 'text/html'), sec = doc.querySelector('.shopify-section');
      el.innerHTML = sec ? sec.innerHTML : doc.body.innerHTML;
    }

    /* the count the header shows now (0 when it shows none) */
    function shownCount() {
      var el = icon(), b = el && el.querySelector('.cart-count-bubble span[aria-hidden="true"]');
      return b ? (Number(b.textContent.trim()) || 0) : 0;
    }
    /* the header's count drawn fresh - a page brought back by Back can show the browser's old copy */
    function fetchBubble() {
      return fetch(location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; }).then(bubble, function () {});
    }
    function visible(el) { return !!el && !el.closest('[hidden]') && el.getClientRects().length > 0; }
    function iconShown() { var el = icon(); return !!el && el.getClientRects().length > 0 && el.getBoundingClientRect().width > 0; }
    /* a control that just hid itself must not drop the keyboard's place to the top of the page */
    function keepFocus(had, box, after) {
      if (!had || had === document.body || visible(had)) return;
      var wrap = box.closest('.quick-add'), form = box.closest('form');
      var to = after === 'add' ? box.querySelector('[data-wsi-add]')
        : (wrap && wrap.querySelector('.quick-add__submit')) || (form && form.querySelector('.product-form__submit'));
      if (to && visible(to)) to.focus();
    }

    /* every card and the product page, from the boxes in the cart */
    function paint() {
      var st = core.state;
      document.querySelectorAll('[data-wsi-incart]').forEach(function (box) {
        var n = st[box.getAttribute('data-product-id')] || 0, wrap = box.closest('.quick-add');
        var num = box.querySelector('[data-wsi-n]'), add = box.querySelector('[data-wsi-add]');
        if (num) num.textContent = String(n);
        if (add) add.disabled = box.getAttribute('data-available') !== 'true';
        box.hidden = n === 0;
        if (wrap) wrap.classList.toggle('wsi-has', n > 0);
        var view = box.querySelector('[data-wsi-viewcart]');   /* no cart icon on the page (the splash page) */
        if (view) view.hidden = n === 0 || iconShown();
      });
      document.querySelectorAll('[data-wsi-incart-line]').forEach(function (line) {
        var n = st[line.getAttribute('data-product-id')] || 0, num = line.querySelector('[data-wsi-n]');
        if (num) num.textContent = String(n);
        line.hidden = n === 0;
      });
    }
    /* only the newest answer paints: two reads in flight cannot paint an older cart over a newer one */
    function use(c, my) {
      if (c && c.items && my === seq) {
        core.state = counts(c);
        paint();
        var n = Number(c.item_count) || 0;
        if (n < 100 && shownCount() !== n) fetchBubble();   /* the header can be an old copy (Back, another tab) */
      }
      return c;
    }
    function refresh() {
      var my = ++seq;
      return fetch(route('cart_url', '/cart') + '.js', { credentials: 'same-origin', headers: { accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { return use(c, my); }, function () { return null; });
    }
    core.refresh = refresh;

    /* a cart change; Shopify's refusal (or no answer within 10 s) becomes an Error with words for the shopper */
    function post(url, body) {
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, 10000) : 0;
      return fetch(url, { method: 'POST', credentials: 'same-origin', signal: ctl ? ctl.signal : undefined,
                          headers: { 'content-type': 'application/json', accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) {
          return r.json().catch(function () { return null; }).then(function (j) {
            clearTimeout(timer);
            if (!r.ok) throw new Error(errorText(r.status, j));
            return j;
          });
        }, function () { clearTimeout(timer); throw new Error(errorText(0, null)); });
    }

    function note(el, text) {
      var wrap = el.closest('.quick-add'), m = (wrap && wrap.querySelector('[data-wsi-msg]')) || el.querySelector('[data-wsi-msg]');
      if (!m) return;
      m.textContent = text;
      m.hidden = false;
      say(text);   /* a status line that was hidden is not read out on its own */
      clearTimeout(m.wsiTimer);
      m.wsiTimer = setTimeout(function () { m.hidden = true; }, 5000);
    }

    function pulse() {
      var el = icon();
      if (!el) return;
      el.classList.remove('wsi-cart-pulse');
      void el.offsetWidth;
      el.classList.add('wsi-cart-pulse');
      setTimeout(function () { el.classList.remove('wsi-cart-pulse'); }, 450);
    }

    /* the pink plane flies from the button to the cart in about half a second; reduced motion: the cart icon only glows */
    function fly(from) {
      var target = icon();
      var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (!target || !from || reduce || typeof Element.prototype.animate !== 'function') { pulse(); return; }
      var src = (from.querySelector && from.querySelector('.wsi-plane-ico')) || from, a = src.getBoundingClientRect();
      var start = { x: a.left + a.width / 2, y: a.top + a.height / 2 };
      var end = landing(target.getBoundingClientRect(), window.innerWidth, window.innerHeight);
      var p = document.createElement('div');
      p.className = 'wsi-plane-fly';
      p.setAttribute('aria-hidden', 'true');
      p.innerHTML = PLANE;
      document.body.appendChild(p);   /* on <body>: iOS clips position:fixed inside a scrolling box */
      var anim = p.animate(flightKeyframes(start, end, 30), { duration: 520, easing: 'cubic-bezier(.45,0,.7,.35)', fill: 'forwards' });
      anim.onfinish = function () {
        var r = p.getBoundingClientRect(), ir = target.getBoundingClientRect();
        core.lastFlight = { end: { x: r.left + r.width / 2, y: r.top + r.height / 2 },
                            icon: { left: ir.left, top: ir.top, right: ir.right, bottom: ir.bottom } };
        p.remove();
        pulse();
      };
      anim.oncancel = function () { p.remove(); };
    }

    /* one box into the cart from a card - no popup; the count changes only once Shopify has said yes */
    function addOne(box, from) {
      var pid = box.getAttribute('data-product-id'), title = box.getAttribute('data-title') || 'It', had = document.activeElement;
      fly(from);
      return run(pid, function () {
        return post(route('cart_add_url', '/cart/add') + '.js', { items: [{ id: Number(box.getAttribute('data-variant-id')), quantity: 1 }],
                                                                 sections: 'cart-icon-bubble', sections_url: location.pathname })
          .then(function (j) { bubble(j && j.sections); return refresh(); })
          .then(function () { say('Added ' + title + ': ' + (core.state[pid] || 0) + ' in your cart'); keepFocus(had, box, 'add'); })
          .catch(function (e) { note(box, e.message); return refresh(); });
      });
    }

    /* one box out of the cart (the product's plain line first) */
    function removeOne(box) {
      var pid = box.getAttribute('data-product-id'), title = box.getAttribute('data-title') || 'It', had = document.activeElement;
      return run(pid, function () {
        return refresh().then(function (c) {
          if (!c) throw new Error(errorText(0, null));
          var li = lastLine(c, pid);
          if (!li) return null;
          return post(route('cart_change_url', '/cart/change') + '.js', { id: li.key, quantity: li.quantity - 1,
                                                                         sections: 'cart-icon-bubble', sections_url: location.pathname })
            .then(function (j) {
              bubble(j && j.sections);
              use(j, ++seq);
              say('Removed one box of ' + title + ': ' + (core.state[pid] || 0) + ' left');
              keepFocus(had, box, 'remove');
            });
        }).catch(function (e) { note(box, e.message); return refresh(); });
      });
    }

    /* a card's own Add to cart is Shopify's form - taken over so no popup opens. The product page's form is left to
       Shopify (its popup); only the plane is added there. */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches) return;
      if (f.matches('form[data-wsi-card]')) {
        var wrap = f.closest('.quick-add'), box = wrap && wrap.querySelector('[data-wsi-incart]');
        if (!box) return;
        e.preventDefault();
        e.stopPropagation();
        addOne(box, f.querySelector('.quick-add__submit'));
      } else if (f.matches('form[data-type="add-to-cart-form"]')) {
        fly(f.querySelector('[name="add"]'));
      }
    }, true);

    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-wsi-add],[data-wsi-remove],[data-wsi-continue]') : null;
      if (!t) return;
      if (t.hasAttribute('data-wsi-add')) {
        e.preventDefault();
        var box = t.closest('[data-wsi-incart]');
        if (box) addOne(box, t);
      } else if (t.hasAttribute('data-wsi-remove')) {
        e.preventDefault();
        var host = t.closest('[data-wsi-incart],[data-wsi-incart-line]');
        if (host) removeOne(host);
      } else if (t.closest('cart-notification')) {
        var d = backTarget(read(BACK), location.href, document.referrer, history.length, cfg.page);
        if (d.mode === 'back') { e.preventDefault(); history.back(); }
        else if (d.mode === 'go') { e.preventDefault(); keep(GO, d.url); location.href = d.url; }
        /* 'close': Shopify's own handler closes the popup */
      } else {
        /* the cart page's links (Shopify redraws them after a quantity change, so the address is set again here) */
        var saved = read(BACK);
        if (saved && saved.url) { t.setAttribute('href', saved.url); keep(GO, saved.url); }
      }
    }, true);

    if (cfg.page === 'cart') {
      var there = continueHref(read(BACK));
      document.querySelectorAll('a[data-wsi-continue]').forEach(function (el) { el.setAttribute('href', there); });
    }

    /* a listing page is remembered (address + scroll) whenever the shopper leaves it, and scrolled back on return */
    if (isListing(cfg.page, cfg.suffix)) {
      var remember = function () { keep(BACK, { url: location.href, y: Math.round(window.pageYOffset || 0) }); };
      window.addEventListener('pagehide', remember);
      document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('a[href*="/products/"]')) remember(); }, true);
      var go = read(GO);
      if (go && sameUrl(go, location.href)) {
        keep(GO, null);
        var s = read(BACK), y = s && sameUrl(s.url, location.href) ? s.y : 0;
        if (y > 0) {
          var to = function () { window.scrollTo(0, y); };
          to();
          window.addEventListener('load', to, { once: true });
          setTimeout(to, 700);
        }
      }
    }

    /* back to a page the browser kept (Back): what was added elsewhere shows here too */
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });   /* use() redraws an old header count */
    document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
    try { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, function () { refresh(); }); } catch (e) {}

    /* cards that arrive later ("You may also like", Shopify's options picker) are painted too */
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        for (var j = 0; j < records[i].addedNodes.length; j++) {
          var n = records[i].addedNodes[j];
          if (n.nodeType === 1 && (n.matches('[data-wsi-incart],[data-wsi-incart-line]') || n.querySelector('[data-wsi-incart],[data-wsi-incart-line]'))) { paint(); return; }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });

    /* first look: an empty header cart means nothing to read */
    /* a page brought back by Back can be the browser's old copy, its header too: then the cart is always read */
    var nav = (window.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    var bub = icon();
    if (nav.type !== 'back_forward' && bub && !bub.querySelector('.cart-count-bubble')) paint();
    else if (window.requestIdleCallback) window.requestIdleCallback(function () { refresh(); }, { timeout: 1500 });
    else setTimeout(refresh, 200);
  };

  return core;
});
